const EXERCISE_LOG_SUMMARIES_ACTION = {
  CREATE: 'EXERCISE_LOG_SUMMARIES_CREATE',
  LOAD: 'EXERCISE_LOG_SUMMARIES_LOAD',
  LOAD_BY_EXERCISE_ID: 'EXERCISE_LOG_SUMMARIES_LOAD_BY_EXERCISE_ID',
  SAVE: 'EXERCISE_LOG_SUMMARIES_SAVE',
  UPDATE_ONE_REP_MAX: 'EXERCISE_LOG_SUMMARIES_UPDATE_ONE_REP_MAX'
}

const EXERCISE_LOG_SUMMARIES_ENDPOINT = {
  EXERCISE_LOG_SUMMARIES: '/exercise-log-summaries',
  EXERCISE_LOG_SUMMARIES_BY_EXERCISE_ID: '/exercise-log-summaries/exercise'
}

const EXERCISE_LOG_SUMMARIES_ANALYTICS_EVENT = {
  ONE_REP_MAX_UPDATED: 'Exercise Log Summaries One Rep Max Updated'
}

const EXERCISE_LOG_SUMMARIES_DOMAIN = 'exerciseLogSummaries'

const EXERCISE_LOG_SUMMARIES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data',
  EXERCISE_ID_MAP: 'exerciseIdMap'
}

const EXERCISE_LOG_SUMMARIES_PATH = {
  ALL: `${EXERCISE_LOG_SUMMARIES_DOMAIN}.${EXERCISE_LOG_SUMMARIES_KEY.ALL}`,
  ALL_DATA: `${EXERCISE_LOG_SUMMARIES_DOMAIN}.${EXERCISE_LOG_SUMMARIES_KEY.ALL}.data`,
  CURRENT: `${EXERCISE_LOG_SUMMARIES_DOMAIN}.${EXERCISE_LOG_SUMMARIES_KEY.CURRENT}`,
  DATA: `${EXERCISE_LOG_SUMMARIES_DOMAIN}.${EXERCISE_LOG_SUMMARIES_KEY.DATA}`,
  EXERCISE_ID_MAP: `${EXERCISE_LOG_SUMMARIES_DOMAIN}.${EXERCISE_LOG_SUMMARIES_KEY.EXERCISE_ID_MAP}`
}

const EXERCISE_LOG_SUMMARIES_STATE = {
  [EXERCISE_LOG_SUMMARIES_KEY.ALL]: {
    data: [],
    status: null
  },
  [EXERCISE_LOG_SUMMARIES_KEY.CURRENT]: null,
  [EXERCISE_LOG_SUMMARIES_KEY.DATA]: {},
  [EXERCISE_LOG_SUMMARIES_KEY.EXERCISE_ID_MAP]: {}
}

export {
  EXERCISE_LOG_SUMMARIES_KEY,
  EXERCISE_LOG_SUMMARIES_ENDPOINT,
  EXERCISE_LOG_SUMMARIES_ACTION,
  EXERCISE_LOG_SUMMARIES_DOMAIN,
  EXERCISE_LOG_SUMMARIES_PATH,
  EXERCISE_LOG_SUMMARIES_STATE,
  EXERCISE_LOG_SUMMARIES_ANALYTICS_EVENT
}
